import { isObjectLike } from 'lodash';

import { updateProductExclusion } from 'containers/Products/Product/store';

import { mapTreeSelectIds, replaceItemInArray } from 'utils';

import { ProductExclusion, ProductExclusionUpdate } from 'codegen';
import { IDataResponse, TRequestCallback } from 'types';

export const getFormattedProductExclusions = (identity: ProductExclusion) => ({
  ...identity,
  retailers: identity.retailers?.map((merchant) => ({ ...merchant, label: merchant.name, value: `${merchant.id}-${merchant.company.id}` })),
});

export const handlePatchExclusions = (
  onPatchTableData: TRequestCallback<ProductExclusionUpdate>,
  productId?: string,
) => ({
  id,
  retailers: ret,
  ...rest
}: ProductExclusion) => {
  const retailers = ret.find(isObjectLike)
    ? ret.map((merchant) => ({ id: mapTreeSelectIds(merchant.id) }))
    : ret.map((ID) => ({ id: mapTreeSelectIds(String(ID)) }));

  const payload = {
    ...rest,
    retailers,
  };

  onPatchTableData({
    payload,
    callbackURL: `/products/details/${productId}/exclusions/${id}`,
  });
};

export const handleSuccessPatchExclusions = (
  exclusion: ProductExclusion[],
) => (
  { data }: IDataResponse<ProductExclusion>,
) => {
  const formattedExclusion = getFormattedProductExclusions(data);

  updateProductExclusion(replaceItemInArray(exclusion, formattedExclusion));
};

export const handlePostExclusions = (
  onPostTableData: TRequestCallback<ProductExclusionUpdate>,
  productId?: string,
) => ({
  retailers,
  ...rest
}: ProductExclusion) => {
  const payload = {
    ...rest,
    isActive: true,
    retailers: retailers?.map((id) => ({ id: mapTreeSelectIds(id as unknown as string) })),
  };

  onPostTableData({
    payload,
    callbackURL: `/products/details/${productId}/exclusions`,
  });
};

export const handleSuccessPostExclusions = (
  exclusion: ProductExclusion[],
) => (
  { data }: IDataResponse<ProductExclusion>,
) => {
  const formattedExclusion = getFormattedProductExclusions(data);

  updateProductExclusion([...exclusion, formattedExclusion]);
};
